import { render, staticRenderFns } from "./loginBox.vue?vue&type=template&id=74d20cb8"
import script from "./loginBox.vue?vue&type=script&lang=js"
export * from "./loginBox.vue?vue&type=script&lang=js"
import style0 from "./loginBox.vue?vue&type=style&index=0&id=74d20cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserSigin: require('/root/workspace/web-company_Yo6Q/components/userLogin/userSigin.vue').default,UserRegister: require('/root/workspace/web-company_Yo6Q/components/userLogin/userRegister.vue').default,UserReset: require('/root/workspace/web-company_Yo6Q/components/userLogin/userReset.vue').default,UserQrcode: require('/root/workspace/web-company_Yo6Q/components/userLogin/userQrcode.vue').default,UserDealer: require('/root/workspace/web-company_Yo6Q/components/userLogin/userDealer.vue').default,UserMpopup: require('/root/workspace/web-company_Yo6Q/components/userLogin/userMpopup.vue').default})
